// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/features/index.css
// module id = 2048
// module chunks = 0